import "./header.css";

const HeaderData =
    [
      {
        title: "Home",
        path: "/home",
        id: 1
      },
  
      {
        title: "About",
        path: "/about",
        id: 2
      },

      {
        title: "Programme",
        path: "/programme",
        id: 3
      },

      {
        title: "Contact",
        path: "/contact",
        id: 4
      },
    ]

 
export default HeaderData;